'use strict';

var _require = require('./Component'),
    DebounceInput = _require.DebounceInput;

module.exports = DebounceInput;


//////////////////
// WEBPACK FOOTER
// ./~/react-debounce-input/lib/index.js
// module id = 1425
// module chunks = 0